import {
    UPDATE_DESTINATION_CODES_REQUEST,
    UPDATE_DESTINATION_CODES_SUCCESS,
    UPDATE_DESTINATION_CODES_ERROR
  } from "./UpdateDestinationCodesTypes";
  
  const initialState = {
    loading: false,
    error: "",
    destinationCodes: []
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case UPDATE_DESTINATION_CODES_REQUEST:
        return {
          ...state,
          loading: true
        };
      case UPDATE_DESTINATION_CODES_SUCCESS:
        // do something
        return {
          ...state,
          loading: false,
          destinationCodes: action.payload,
          error: ""
        };
      case UPDATE_DESTINATION_CODES_ERROR:
        return {
          ...state,
          loading: false,
          destinationCodes: [],
          error: action.payload
        };
      default:
        return state;
    }
  };
  